import { createRoot } from 'react-dom/client'
import { Suspense, lazy } from 'react'
import './index.css'

// Preload the App component for faster loading
const App = lazy(() => import('./App.tsx').then(module => {
  // Preload critical resources immediately when App loads
  return { default: module.default };
}));

// Minimal loading component for instant paint
const LoadingFallback = () => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'hsl(40 25% 98%)',
    color: 'hsl(20 25% 15%)'
  }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{ 
        width: '32px', 
        height: '32px', 
        border: '3px solid hsl(35 15% 88%)', 
        borderTop: '3px solid hsl(20 40% 35%)', 
        borderRadius: '50%', 
        animation: 'spin 1s linear infinite',
        margin: '0 auto 16px'
      }}></div>
      <p>Chargement...</p>
    </div>
  </div>
)

createRoot(document.getElementById("root")!).render(
  <Suspense fallback={<LoadingFallback />}>
    <App />
  </Suspense>
);
